import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { RequireAuth } from './components/RequireAuth.js';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <RequireAuth>{(user) => <App user={user} />}</RequireAuth>
    </BrowserRouter>
  </React.StrictMode>,
);
